import { IconButton, fade } from '@mui/material';
import clsx from 'clsx';
import React, { useState } from 'react';
import { RefreshCw } from 'react-feather';
import Icon from './Icon';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(540deg)'
    }
  },
  spin: {
    animation: '$spin 700ms ease-in-out'
  },
  button: ({ updateRequired, disabled, marginRight }) => ({
    color: updateRequired
      ? theme.palette.primary.main
      : theme.palette.text.primary,
    marginRight: marginRight ?? theme.spacing(1),
    transition: updateRequired
      ? 'transform 375ms ease-in-out, color 375ms ease-in-out, opacity 375ms ease-in-out'
      : 'transform 375ms ease-in-out, color 375ms ease-in-out, opacity 375ms ease-in-out',
    transform: updateRequired ? 'rotate(180deg)' : 'rotate(0deg)',
    '&.Mui-disabled': {
      // color: updateRequired
      //   ? fade(theme.palette.primary.main, disabled ? 0.5 : 1.0)
      //   : fade(theme.palette.text.primary, disabled ? 0.5 : 1.0)

      color: updateRequired
        ? theme.palette.primary.main
        : theme.palette.text.primary,
      opacity: disabled ? 0.5 : 1.0
    }
  })
}));

export default function RefreshButton({ onClick, updateRequired, disabled, size, marginRight }) {
  const classes = useStyles({ updateRequired, disabled, marginRight });
  const [animating, setAnimating] = useState(false);

  const handleClick = () => {
    if (!animating && onClick) {
      setAnimating(true);
      onClick();
    }
  };

  const handleAnimationEnd = () => {
    setAnimating(false);
  }

  return (
    <IconButton
      onClick={handleClick}
      className={animating
        ? clsx(classes.button, classes.spin)
        : classes.button}
      // size="small"
      size={'small'}
      disabled={animating || disabled}
      onAnimationEnd={handleAnimationEnd}
    >
      <RefreshCw size={size} />
      {/* <Icon icon="sync-alt"/> */}
    </IconButton >
  )
}
